'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCreate$002dRequest from "./app.data.-App-Document-Data-Create-Request.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataCreateRequest$Invoice(request) {
  this.a8r = null;
  this.a8r = request;
}
export { $c_Lapp_data_AppDocumentDataCreateRequest$Invoice as $c_Lapp_data_AppDocumentDataCreateRequest$Invoice };
$p = $c_Lapp_data_AppDocumentDataCreateRequest$Invoice.prototype = new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCreate$002dRequest.$h_Lapp_data_AppDocumentDataCreateRequest();
$p.constructor = $c_Lapp_data_AppDocumentDataCreateRequest$Invoice;
/** @constructor */
function $h_Lapp_data_AppDocumentDataCreateRequest$Invoice() {
}
export { $h_Lapp_data_AppDocumentDataCreateRequest$Invoice as $h_Lapp_data_AppDocumentDataCreateRequest$Invoice };
$h_Lapp_data_AppDocumentDataCreateRequest$Invoice.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentDataCreateRequest$Invoice)) {
    var x = this.a8r;
    var x$2 = x$0.a8r;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "Invoice";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.a8r;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "request";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 1;
});
function $isArrayOf_Lapp_data_AppDocumentDataCreateRequest$Invoice(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iQ)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataCreateRequest$Invoice as $isArrayOf_Lapp_data_AppDocumentDataCreateRequest$Invoice };
var $d_Lapp_data_AppDocumentDataCreateRequest$Invoice = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataCreateRequest$Invoice, "app.data.AppDocumentDataCreateRequest$Invoice", ({
  iQ: 1,
  dC: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_AppDocumentDataCreateRequest$Invoice as $d_Lapp_data_AppDocumentDataCreateRequest$Invoice };
//# sourceMappingURL=app.data.-App-Document-Data-Create-Request$-Invoice.js.map
